__turbopack_context__.v({
  "details": "CollapseDetails-module__ubZAlq__details",
  "fadeInItems": "CollapseDetails-module__ubZAlq__fadeInItems",
  "row": "CollapseDetails-module__ubZAlq__row",
  "spacing--lg": "CollapseDetails-module__ubZAlq__spacing--lg",
  "spacing--md": "CollapseDetails-module__ubZAlq__spacing--md",
  "spacing--sm": "CollapseDetails-module__ubZAlq__spacing--sm",
  "spacing--xl": "CollapseDetails-module__ubZAlq__spacing--xl",
  "spacing--xs": "CollapseDetails-module__ubZAlq__spacing--xs",
  "spacing--xxl": "CollapseDetails-module__ubZAlq__spacing--xxl",
  "spacing--xxs": "CollapseDetails-module__ubZAlq__spacing--xxs",
  "spacing--xxxl": "CollapseDetails-module__ubZAlq__spacing--xxxl",
  "spacing--xxxs": "CollapseDetails-module__ubZAlq__spacing--xxxs",
  "summary": "CollapseDetails-module__ubZAlq__summary",
  "title": "CollapseDetails-module__ubZAlq__title",
});
